import React, { Component } from "react";
import { Card, Table, Button, Row, Col, Modal, Form, Alert } from "react-bootstrap";
import { FaPlus, FaRegEdit, FaTrash, FaCheck } from "react-icons/fa";
import api from "../../services/api";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Paginacao from '../../common/pagination';
import { IMaskInput } from "react-imask";

class ProgramaMensageriaRecorrente extends Component {
    constructor(props) {
        super(props);

        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listMensageria: [],
            loading: true,
            loadingModal: false,
            error: '',
            page_numb: 1,
            
            // Doencas para o select
            doencas: [],
            loadingDoencas: false,

            // Modal
            showModal: false,
            modalTitulo: '',
            
            // Campos do formulário
            id: null,
            nome: '',
            template_whatsapp: '',
            dia_mes_envio: '',
            doenca_id: '',
            
            // Erros de validação
            nomeError: '',
            template_whatsappError: '',
            dia_mes_envioError: '',
            doenca_idError: '',
        };
    }

    componentDidMount() {
        this.carregarMensageria(this.state.page_numb);
        this.carregarDoencas();
    }

    carregarMensageria = (page_numb = 1) => {
        const { programaId } = this.props;

        if (!programaId) {
            this.setState({ loading: false, error: 'ID do programa não informado' });
            return;
        }

        this.setState({ loading: true, error: '' });

        api.get(`/programas/messageria-recorrente/?programa_id=${programaId}&page=${page_numb}`)
            .then(response => {
                this.setState({
                    listMensageria: response.data,
                    loading: false,
                    error: '',
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao carregar mensageria recorrente';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg,
                });
            });
    };

    carregarDoencas = () => {
        const { programaId } = this.props;

        this.setState({ loadingDoencas: true });

        api.get(`/programas/doencas/?programa_id=${programaId}&page_size=100`)
            .then(response => {
                this.setState({
                    doencas: response.data.results || [],
                    loadingDoencas: false,
                });
            })
            .catch(error => {
                console.error('Erro ao carregar doenças:', error);
                this.setState({ loadingDoencas: false });
            });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.carregarMensageria(num_page);
    }

    formatarDiaMes = (diaMes) => {
        if (!diaMes || diaMes.length !== 4) return '-';
        const dia = diaMes.substring(0, 2);
        const mes = diaMes.substring(2, 4);
        const meses = ['', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        const mesNum = parseInt(mes, 10);
        return `${dia}/${meses[mesNum] || mes}`;
    };

    getDoencaNome = (doenca_id) => {
        const doenca = this.state.doencas.find(d => d.doenca_id === doenca_id || d.id === doenca_id);
        return doenca ? (doenca.dados_doenca?.nome || doenca.nome || '-') : '-';
    };

    abrirModalNovo = () => {
        this.setState({
            showModal: true,
            modalTitulo: 'Adicionar Mensageria Recorrente',
            id: null,
            nome: '',
            template_whatsapp: '',
            dia_mes_envio: '',
            doenca_id: '',
            nomeError: '',
            template_whatsappError: '',
            dia_mes_envioError: '',
            doenca_idError: '',
        });
    };

    abrirModalEditar = (item) => {
        this.setState({
            showModal: true,
            modalTitulo: 'Editar Mensageria Recorrente',
            id: item.id,
            nome: item.nome || '',
            template_whatsapp: item.template_whatsapp || '',
            dia_mes_envio: item.dia_mes_envio || '',
            doenca_id: item.doenca_id || '',
            nomeError: '',
            template_whatsappError: '',
            dia_mes_envioError: '',
            doenca_idError: '',
        });
    };

    fecharModal = () => {
        this.setState({
            showModal: false,
            id: null,
            nome: '',
            template_whatsapp: '',
            dia_mes_envio: '',
            doenca_id: '',
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, [`${name}Error`]: '' });
    };

    validarFormulario = () => {
        let valido = true;

        if (!this.state.nome.trim()) {
            this.setState({ nomeError: 'Nome é obrigatório' });
            valido = false;
        }

        if (!this.state.template_whatsapp.trim()) {
            this.setState({ template_whatsappError: 'Template WhatsApp é obrigatório' });
            valido = false;
        }

        if (!this.state.dia_mes_envio || this.state.dia_mes_envio.length !== 4) {
            this.setState({ dia_mes_envioError: 'Informe o dia e mês no formato DDMM' });
            valido = false;
        } else {
            const dia = parseInt(this.state.dia_mes_envio.substring(0, 2), 10);
            const mes = parseInt(this.state.dia_mes_envio.substring(2, 4), 10);
            if (dia < 1 || dia > 31 || mes < 1 || mes > 12) {
                this.setState({ dia_mes_envioError: 'Data inválida' });
                valido = false;
            }
        }

        if (!this.state.doenca_id) {
            this.setState({ doenca_idError: 'Selecione uma doença' });
            valido = false;
        }

        return valido;
    };

    salvar = async () => {
        if (!this.validarFormulario()) {
            return;
        }

        const { programaId } = this.props;
        const { id, nome, template_whatsapp, dia_mes_envio, doenca_id } = this.state;

        this.setState({ loadingModal: true });

        const dados = {
            programa_id: programaId,
            nome,
            template_whatsapp,
            dia_mes_envio,
            doenca_id: parseInt(doenca_id, 10),
        };

        const url = id ? `/programas/messageria-recorrente/${id}/` : '/programas/messageria-recorrente/';
        const metodo = id ? 'put' : 'post';

        try {
            await api({
                method: metodo,
                url: url,
                data: dados,
            });

            const MySwal = withReactContent(Swal);
            const textSwal = id ? 'Mensageria atualizada com sucesso' : 'Mensageria cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ loadingModal: false });
            this.fecharModal();
            this.carregarMensageria(this.state.page_numb);

        } catch (error) {
            let erro_msg = 'Erro ao salvar, verifique os campos e tente novamente';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                
                if (campos.nome) this.setState({ nomeError: campos.nome });
                if (campos.template_whatsapp) this.setState({ template_whatsappError: campos.template_whatsapp });
                if (campos.dia_mes_envio) this.setState({ dia_mes_envioError: campos.dia_mes_envio });
                if (campos.doenca_id) this.setState({ doenca_idError: campos.doenca_id });
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });

            this.setState({ loadingModal: false });
        }
    };

    excluir = (item) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Você tem certeza?',
            text: 'Esta ação não pode ser desfeita!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await api.delete(`/programas/messageria-recorrente/${item.id}/`);

                    MySwal.fire(
                        'Excluído!',
                        'Registro excluído com sucesso.',
                        'success'
                    );

                    this.carregarMensageria(this.state.page_numb);

                } catch (error) {
                    let erro_msg = 'Erro ao excluir';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    }

                    MySwal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: erro_msg,
                    });
                }
            }
        });
    };

    renderRows = () => {
        if ('results' in this.state.listMensageria && this.state.listMensageria.results.length > 0) {
            return this.state.listMensageria.results.map((item) => (
                <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nome}</td>
                    <td>{item.template_whatsapp}</td>
                    <td>{this.formatarDiaMes(item.dia_mes_envio)}</td>
                    <td>{this.getDoencaNome(item.doenca_id)}</td>
                    <td>
                        <Button 
                            variant="light" 
                            size="sm" 
                            className="me-1"
                            onClick={() => this.abrirModalEditar(item)}
                        >
                            <FaRegEdit /> Editar
                        </Button>
                        <Button 
                            variant="danger" 
                            size="sm"
                            onClick={() => this.excluir(item)}
                        >
                            <FaTrash /> Excluir
                        </Button>
                    </td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={6}>Nenhuma mensageria recorrente cadastrada para este programa</td>
            </tr>
        );
    };

    render() {
        const { 
            loading, 
            loadingModal,
            error, 
            listMensageria,
            page_numb,
            showModal,
            modalTitulo,
            nome,
            template_whatsapp,
            dia_mes_envio,
            doenca_id,
            nomeError,
            template_whatsappError,
            dia_mes_envioError,
            doenca_idError,
            doencas,
            loadingDoencas,
        } = this.state;

        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h4>Mensageria Recorrente</h4>
                            </Col>
                            <Col sm={6} lg={6} className="text-end">
                                <Button variant="secondary" size="sm" onClick={this.abrirModalNovo}>
                                    <FaPlus /> Adicionar Mensageria
                                </Button>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Template WhatsApp</th>
                                    <th>Dia/Mês Envio</th>
                                    <th>Doença</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={6}>Carregando...</td>
                                    </tr>
                                ) : (
                                    error ? (
                                        <tr>
                                            <td colSpan={6}>{error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>

                        {'results' in listMensageria && listMensageria.results.length > 0 && 
                            <Paginacao 
                                dados={listMensageria} 
                                loading={loading} 
                                page_numb={page_numb} 
                                _onClickPagina={this.onClickPagina} 
                            />
                        }
                    </Card.Body>
                </Card>

                {/* Modal Cadastro/Edição */}
                <Modal 
                    show={showModal} 
                    onHide={this.fecharModal}
                    size="lg"
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nome <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="nome"
                                            value={nome}
                                            onChange={this.handleChange}
                                            placeholder="Nome da mensageria"
                                        />
                                        {nomeError && (
                                            <Form.Text className="text-danger">{nomeError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Template WhatsApp <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="template_whatsapp"
                                            value={template_whatsapp}
                                            onChange={this.handleChange}
                                            placeholder="Nome do template"
                                        />
                                        {template_whatsappError && (
                                            <Form.Text className="text-danger">{template_whatsappError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Dia/Mês de Envio <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            as={IMaskInput}
                                            mask="0000"
                                            name="dia_mes_envio"
                                            value={dia_mes_envio}
                                            onChange={this.handleChange}
                                            placeholder="DDMM (ex: 0912 = 09/Dez)"
                                        />
                                        <Form.Text className="text-muted">
                                            Formato: DDMM (exemplo: 0912 para dia 09 de Dezembro)
                                        </Form.Text>
                                        {dia_mes_envioError && (
                                            <Form.Text className="text-danger d-block">{dia_mes_envioError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Doença <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="doenca_id"
                                            value={doenca_id}
                                            onChange={this.handleChange}
                                            disabled={loadingDoencas}
                                        >
                                            <option value="">
                                                {loadingDoencas ? 'Carregando doenças...' : 'Selecione uma doença'}
                                            </option>
                                            {doencas.map(doenca => (
                                                <option key={doenca.doenca_id || doenca.id} value={doenca.doenca_id || doenca.id}>
                                                    {doenca.dados_doenca?.nome || doenca.nome}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        {doenca_idError && (
                                            <Form.Text className="text-danger">{doenca_idError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModal}>
                            Cancelar
                        </Button>
                        <Button 
                            variant="success" 
                            onClick={this.salvar}
                            disabled={loadingModal}
                        >
                            {loadingModal ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ProgramaMensageriaRecorrente;
